export { default } from './Buildings';
